import { Box, SxProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { CropOriginal } from "@mui/icons-material";
import { Skeleton } from "@mui/material";
import { MuiNavLink } from "@components/_Misc";

interface Props {
  title: string;
  alt: string;
  link: string;
  image_url?: string | null;
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
    fontWeight: "bold",
    // color: "#ffffffde",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    display: "-webkit-box",
    maxWidth: 130, // max width of the image!
    textDecoration: "none",
    width: "100%",
    userSelect: "none",
    msUserSelect: "none",
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "transparent",
  },
  link: {
    display: "block",
    textDecoration: "none",
    userSelect: "none",
    msUserSelect: "none",
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    WebkitTouchCallout: "none",
    WebkitTapHighlightColor: "transparent",
  },
  image: {
    height: 195,
    width: 130,
    borderRadius: theme.spacing(0.625),
  },
  imageDefault: {
    color: "white",
    backgroundColor: "#808080cc",
  },
}));

export const PosterCard: React.FC<Props> = ({ alt, image_url, link, title }) => {
  const classes = useStyles();

  const ImageElement = () => {
    const sxSvg: SxProps = image_url ? {} : { color: "white", backgroundColor: "#808080cc" };
    return (
      <Box
        component={image_url ? "img" : CropOriginal}
        sx={{ height: 195, width: 130, borderRadius: 1, ...sxSvg }}
        src={image_url || undefined}
        alt={alt}
        title={title}
        loading="lazy"
      />
    );
  };

  return (
    <div>
      <MuiNavLink to={link} className={classes.link} color="text.primary">
        <ImageElement />
        <div title={title} className={classes.title}>
          {title}
        </div>
      </MuiNavLink>
    </div>
  );
};

export const PosterCardSkeletonRow = ({ uid }: { uid: string }) => {
  return (
    <>
      {Array.from({ length: 10 }).map((_, i) => (
        <Box
          display="flex"
          flexDirection={"column"}
          alignItems={"center"}
          width={130}
          marginRight={4}
          key={`${i}_${uid}_skel`}
        >
          <Skeleton variant="rectangular" style={{ borderRadius: 5 }} width={130} height={195} />
          <Skeleton variant="text" width={120} />
        </Box>
      ))}
    </>
  );
};
